import React, { useState, useEffect } from 'react';
import { Route, withRouter, Switch } from "react-router-dom";
import { Scrollbars } from 'react-custom-scrollbars';
import { throttle } from 'lodash';
import styled from 'styled-components';

import Index from './pages/index/Index';
import Settings from './pages/settings/Settings';
import SettingsError from '../error_components/Settings_error';

const ContentStyled = styled.div`
    color: ${props => props.theme.content.color};
    height: 100%;
    overflow-x: initial;
`;

const Content = ({ location }) => {
    const [winHeight, setWinHeight] = useState(window.innerHeight < 600 ? window.innerHeight - 166 : 400);
    const resizeHandler = throttle(() => {
        setWinHeight(window.innerHeight < 600 ? window.innerHeight - 166 : 400);
    }, 500, { 'leading': true });

    useEffect(() => {
        window.addEventListener('resize', resizeHandler);
    },[])

    return (
        <Scrollbars
            hideTracksWhenNotNeeded={true}
            style={{ height: winHeight }}>
            <ContentStyled>
                <SettingsError>
                    <Switch location={location}>
                        <Route path="/" exact component={Index}></Route>
                        <Route path="/settings" component={Settings}></Route>
                    </Switch>
                </SettingsError>
            </ContentStyled>
        </Scrollbars>
    );
};

export default withRouter(Content);